export const groupNameUpdateAction = (groupName) => {
  window.groupName = groupName;
  const groupNameTag = document.querySelector('.storeeel-group-name_h2');
  if (!groupNameTag) {
    return;
  }
  groupNameTag.textContent = groupName;
}
